import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'a-mention',
    templateUrl: './a-mention.component.html',
    styleUrls: ['./a-mention.component.scss'],
    standalone: false
})
export class AMentionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
